/**
 * Parse Account / Create-User QR payloads.
 * Accepts any URL with org=<JWT> (onboarding, signup, or drinkripples://).
 */

export type ParsedOnboardingQr = {
  org: string;
  orgName: string;
  serial?: string;
  isPartner: boolean;
};

type OrgJwtPayload = {
  sub?: string;
  name?: string;
  serial?: string;
  isPartner?: string | boolean;
};

const decodeOrgJwt = (orgToken: string): OrgJwtPayload | null => {
  try {
    const dataPart = orgToken.split('.')[1];
    if (!dataPart) {
      return null;
    }
    return JSON.parse(atob(dataPart)) as OrgJwtPayload;
  } catch {
    return null;
  }
};

export const parseOnboardingQrPayload = (
  raw: string,
): ParsedOnboardingQr | null => {
  try {
    const trimmed = (raw || '').trim();
    if (!trimmed) {
      return null;
    }

    const normalized = trimmed.replace(/^drinkripples:\/\//i, 'https://app/');
    const parsed = new URL(normalized);
    const org = parsed.searchParams.get('org');
    if (!org) {
      return null;
    }

    const payload = decodeOrgJwt(org);
    if (!payload?.name) {
      return null;
    }

    const serial =
      parsed.searchParams.get('serial') || payload.serial || undefined;
    const isPartner =
      parsed.searchParams.get('isPartner') === 'true' ||
      payload.isPartner === true ||
      payload.isPartner === 'true';

    return {
      org,
      orgName: payload.name,
      ...(serial ? { serial } : {}),
      isPartner,
    };
  } catch {
    return null;
  }
};

/** Mobile device signup — use Scan instead of recover checkbox. */
export const isMobileSignupEntry = (): boolean => {
  try {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  } catch {
    return false;
  }
};
